export const CompanyName = {
	IBM: 'IBM',
	Kyndryl: 'Kyndryl'
};

export const HelpText = {
	percentToTwenty: 'A percentage value between 0 and 20',
	buyerContractorId: 'This is the first 6 digits of the serial number (including any dashes)',
	exactly3Digits: 'This should be exactly 3 digits',
	exactly3Alphanumeric: 'This should be exactly 3 alphanumeric characters',
	ilcEnabled: 'Check this if the contractor uses ILC claim codes'
};

export const localStorageKeys = {
	needRunTSTourGuide: 'needRunTSTourGuide'
};

export const HourTypes = {
	straighttime: 'ST',
	standard: 'ST',
	overtime: 'OT',
	doubletime: 'DT',
	standby: 'SD',
	callout: 'CO',
	remotecallout: 'Remote CO',
	onsitecallout: 'Onsite CO'
};

